import directories from './directories'
import info from './info'

export default [
  {
    path: '/user/create',
    name: 'UserCreate',
    component: () => import('@/views/Users/UserCreate.vue')
  },
  {
    path: '/user/list',
    name: 'UserList',
    component: () => import('@/views/Users/UserList.vue')
  },
  {
    path: '/user/subordinates-list/:id',
    name: 'SubordinatesList',
    component: () => import('@/views/Users/SubordinatesList.vue')
  },
  {
    path: '/user/update/:id',
    name: 'UserUpdate',
    component: () => import('@/views/Users/UserUpdate.vue')
  },
  ...info,
  {
    path: '/departments/tree',
    name: 'DepartmentsTree',
    component: () => import('@/views/Users/DepartmentsTree.vue')
  },
  {
    path: '/departments/create',
    name: 'DepartmentCreate',
    component: () => import('@/views/Users/DepartmentCreate.vue')
  },
  {
    path: '/user/groups',
    name: 'UserGroups',
    component: () => import('@/views/Users/UserGroups.vue')
  },
  {
    path: '/user/groups/:id',
    name: 'UserGroupDetail',
    component: () => import('@/views/Users/UserGroupDetail.vue')
  },
  // справочники сотрудников
  ...directories
]
